import React from "react";
import {styled, theme} from "@reside/ui";

type Props = Readonly<{
  onClick: () => void;
}>;

export const PermissionsManagementClearFiltersButton = ({onClick}: Props) => (
  <ClearButton type="button" onClick={onClick}>
    Clear filters
  </ClearButton>
);

const ClearButton = styled.button`
  background: transparent;
  border: none;
  color: ${theme.color.primary};
  cursor: pointer;
  font-family: Gilroy, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;
